import { RequestError } from "typedefs";
import { WorkflowModel } from "app/models";
import { WorkflowAction } from "app/actions/workflow";

export type WorkflowState = {
  data: WorkflowModel[] | null;
  selectedWorkflow: WorkflowModel | null;
  error: RequestError | null;
  pending: boolean;
  createPending: boolean;
  updatePending: boolean;
  deletePending: boolean;
};

const initialState: WorkflowState = {
  data: null,
  selectedWorkflow: null,
  error: null,
  pending: false,
  createPending: false,
  updatePending: false,
  deletePending: false,
};

export default function workflowReducer(
  state = initialState,
  action: WorkflowAction,
): WorkflowState {
  switch (action.type) {
    // List
    case "@workflow.list.pending":
      return { ...state, error: null, pending: true };
    case "@workflow.list.success":
      return { ...state, data: action.payload, pending: false };
    case "@workflow.list.error":
      return { ...state, error: action.payload, pending: false };

    // Single fetch
    case "@workflow.fetch.pending":
      return { ...state, error: null, pending: true };
    case "@workflow.fetch.success":
      return { ...state, selectedWorkflow: action.payload, pending: false };
    case "@workflow.fetch.error":
      return { ...state, error: action.payload, pending: false };

    // Create
    case "@workflow.create.pending":
      return { ...state, error: null, createPending: true };
    case "@workflow.create.success":
      return {
        ...state,
        createPending: false,
        data: state.data ? [action.payload, ...state.data] : [action.payload],
      };
    case "@workflow.create.error":
      return { ...state, error: action.payload, createPending: false };

    // Update (optimistic — API returns 204 No Content)
    case "@workflow.update.pending":
      return { ...state, error: null, updatePending: true };
    case "@workflow.update.success": {
      const { id, params } = action.payload;
      return {
        ...state,
        updatePending: false,
        selectedWorkflow:
          state.selectedWorkflow?.id === id
            ? { ...state.selectedWorkflow, ...params }
            : state.selectedWorkflow,
        data: state.data
          ? state.data.map((w) =>
              w.id === id ? { ...w, ...params } : w,
            )
          : state.data,
      };
    }
    case "@workflow.update.error":
      return { ...state, error: action.payload, updatePending: false };

    // Delete
    case "@workflow.delete.pending":
      return { ...state, error: null, deletePending: true };
    case "@workflow.delete.success":
      return {
        ...state,
        deletePending: false,
        data: state.data
          ? state.data.filter((w) => w.id !== action.payload)
          : state.data,
        selectedWorkflow:
          state.selectedWorkflow?.id === action.payload
            ? null
            : state.selectedWorkflow,
      };
    case "@workflow.delete.error":
      return { ...state, error: action.payload, deletePending: false };

    // Clear
    case "@workflow.clear":
      return { ...state, ...initialState };

    default:
      return state;
  }
}
